module.exports = __webpack_public_path__ + "img/Enmascarar-grupo-2-new.2d0e04bd.png";